import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import WaiterLoginScreen from './screens/Waiter/WaiterLoginScreen';
import TableSelectionScreen from './screens/Waiter/TableSelectionScreen';
import OrderScreen from './screens/Waiter/OrderScreen';
import KitchenDisplayScreen from './screens/Management/KitchenDisplayScreen';
import BarDisplayScreen from './screens/Management/BarDisplayScreen';
import SuperAdminLoginScreen from './screens/Admin/SuperAdminLoginScreen';
import RestaurantManagementScreen from './screens/Admin/RestaurantManagementScreen';
import RestaurantAdminLoginScreen from './screens/Admin/RestaurantAdminLoginScreen';
import RestaurantDashboardScreen from './screens/Admin/RestaurantDashboardScreen';
import ManageWaitersScreen from './screens/Admin/ManageWaitersScreen';
import ManageMenuItemsScreen from './screens/Admin/ManageMenuItemsScreen';
import ManageRestaurantUsersScreen from './screens/Admin/ManageRestaurantUsersScreen';
import ManageDevicesScreen from './screens/Admin/ManageDevicesScreen';
import EditRestaurantProfileScreen from './screens/Admin/EditRestaurantProfileScreen';

function App() {
  return (
    <Router>
      <div className="App">
        <Routes>
          {/* Waiter App Routes */}
          <Route path="/waiter/login" element={<WaiterLoginScreen />} />
          <Route path="/waiter/tables" element={<TableSelectionScreen />} />
          <Route path="/waiter/order/:tableId" element={<OrderScreen />} />

          {/* Management Panel Routes */}
          <Route path="/management/kitchen" element={<KitchenDisplayScreen />} />
          <Route path="/management/bar" element={<BarDisplayScreen />} />

          {/* Super Admin Routes */}
          <Route path="/superadmin/login" element={<SuperAdminLoginScreen />} />
          <Route path="/admin/restaurants" element={<RestaurantManagementScreen />} />

          {/* Restaurant Admin Routes */}
          <Route path="/restaurant/login" element={<RestaurantAdminLoginScreen />} />
          <Route path="/restaurant/dashboard" element={<RestaurantDashboardScreen />} />
          <Route path="/restaurant/manage-users" element={<ManageWaitersScreen />} />
          <Route path="/restaurant/manage-menu" element={<ManageMenuItemsScreen />} />
          <Route path="/restaurant/manage-restaurant-users" element={<ManageRestaurantUsersScreen />} />
          <Route path="/restaurant/manage-devices" element={<ManageDevicesScreen />} />
          <Route path="/restaurant/profile" element={<EditRestaurantProfileScreen />} />

          {/* Default or Home Route */}
          <Route path="/" element={<div>Welcome to Food System! Choose your app: <a href="/waiter/login">Waiter App</a> or <a href="/management/kitchen">Kitchen Display</a> or <a href="/superadmin/login">Super Admin</a> or <a href="/restaurant/login">Restaurant Admin</a></div>} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
